
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dorm-room-storage",
      function () {
        return require("private-next-pages/dorm-room-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dorm-room-storage"])
      });
    }
  